export const state = () => ({
  multipleBlocks: {},
  cashedMultipleBlocks: {},
  cashedMultipleBLocksMeta: {},
  isEdit: true,
  editBlock: "",

})

export const actions = {
  setBlocks({ commit }, params) {
    commit("SET_BLOCKS", params);
  },
  setIsEditStatus({ commit }, params) {
    commit("SET_IS_EDIT", params);
  },
  setBlocksWithData({ commit }, params) {
    const blocks = {}

    const getGuidByType = (cg, type) => {
      switch (type) {
        case 'benefit':
          return cg.specialQuota;
        case 'specquota_fields':
          return cg.extraQuota;
        case 'ldnr_fields':
          return cg.extraQuota;
        case 'targeted':
          return cg.targeted;
        default:
          return '';
      }
    }

    for (let param in params.multiBlocks) {
      const block = [];
      params.multiBlocks[param].map((value, i) => {
        const fields = [];
        for (let field in value.fields) {
          fields.push(value.fields[field]);
        }
        if (value.id) {
          const cG = params.competitiveGroups.find((e) => {
            const result = Object.values(e).find((v) => v == value.id)
            return !!result
          });
          if (cG) {
            const guid = getGuidByType(cG, param);
            if (guid) {
              fields.push({ selectedGroupGuid: guid });
            }
          }
        }
        if (value.prohibition_edit) {
          fields.push({ disabledBlock: value.prohibition_edit });
        }
        if (value.code) {
          fields.push({ code_guid: value.code })
        }
        block.push(fields);
      })

      blocks[param] = block;
    }

    commit('SET_DATA', blocks);
    // commit('SET_CASHED_MULTIPLE_BLOCK_META', metaDataBlocks);
  },
  // setBlocksFromLocalStorage({commit}, {block, values}){
  //   commit("SET_BLOCKS_FROM_LOCALSTORAGE", {
  //     block, 
  //     values: JSON.parse(values),
  //   });
  // },  
  changeBlock({ commit }, params) {
    commit('CHANGE_BLOCK', params);
  },
  createBlock({ commit }, params) {
    commit('CREATE_BLOCK', params)
  },
  changeFieldsOfBlock({ commit }, params) {
    commit("CHANGE_FIELDS_OF_BLOCK", params)
  },
  setIds({ commit }, params) {
    commit("SET_IDS", params);
  },
  addBlockModel({ commit }, params) {
    commit("ADD_BLOCKMODEL", params);
  },
}

export const mutations = {
  SET_BLOCKS(state, params) {
    if (!state.multipleBlocks.hasOwnProperty(params.name)) {
      state.multipleBlocks[params.name] = []
    }
    state.multipleBlocks[params.name] = params.blocks
  },
  SET_DATA(state, params) {
    state.cashedMultipleBlocks = params
  },
  SET_CASHED_MULTIPLE_BLOCK_META(state, params) {
    state.cashedMultipleBLocksMeta = params;
  },
  // SET_DATA_IN_LOCALSTORAGE({state}, params){
  //   const multiBlocks = [];

  //   params.blocks.forEach(block => {
  //     const multiBlock = {};

  //     for (let fields in block) {
  //       if (fields === "fieldValues") { 
  //         multiBlock[fields] = block[fields]; 
  //       }
  //     }

  //     multiBlocks.push(multiBlock);
  //   })

  // localStorage.setItem(`mb/${params.name}`, JSON.stringify(multiBlocks));
  // },
  // SET_BLOCKS_FROM_LOCALSTORAGE(state, {block, values}){
  //   const newBlock = [] 

  //   values.forEach(value => {
  //     newBlock.push(value.fieldValues);
  //   })

  //   state.cashedMultipleBlocks[block.unique] = newBlock
  // },
  ADD_BLOCKMODEL(state, params) {
    if (state.multipleBlocks.hasOwnProperty(params.unique)) {
      state.multipleBlocks[params.unique].forEach(item => item.blockModel = params)
    }
  },
  SET_IS_EDIT(state, params) {
    state.isEdit = !state.isEdit;
    state.editBlock = params;
  },
  CHANGE_BLOCK(state, params) {
    state.multipleBlocks[params.name][params.index].isBlock = params.isBlock
  },
  CHANGE_FIELDS_OF_BLOCK(state, params) {
    state.multipleBlocks[params.name][params.index].fieldValues = params.fields
  },
  SET_IDS(state, params) {
    params.ids.forEach((id, index) => {
      state.multipleBlocks[params.name][index].id = id;
    });
  },
}

export const getters = {
  getMultipleBlocks: (state) => {
    return state.multipleBlocks
  },
  getCashedMultipleBlocks: (state) => {
    return state.cashedMultipleBlocks
  },
  getCashedMultipleBlocksMeta(state) {
    return state.cashedMultipleBLocksMeta;
  },
  getIsEditStatus: (state) => {
    return state.isEdit
  },
  getIsEditBlock: (state) => {
    return state.editBlock
  },
  getIds: (state) => {
    return state.ids
  }
}
